export default __webpack_public_path__ + "media/images/mailer-new/welcome/step5-off-893728076ee51403acb01b8447d37548.png";